import { EXPLORE_ROUTES } from "../exploreRoutes";
import { GAMIFICATION_ROUTES } from "./gamificationRoutes";
import React, { useEffect, useMemo, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HomeDashboardLayout from "../HomeDashboardLayout";
import "../../dashboard/Dashboard.css";
import "../HomeDashboard.css";
import "../questionBank/QuestionBankList.css";
import HeaderProfileSection from "../HeaderProfileSection";
import CreateRoom from "./CreateRoom";
import JoinRoom from "./JoinRoom";
import CoinConverterGif from "../../assets/images/Coin-converter.gif";
import { useGamificationBattleSession } from "../../hooks/useGamificationBattleSession";
import {
  buildGamificationFlowState,
  buildGamificationSubjectsState,
  getStoredGamificationFlowState,
} from "./gamificationFlowState";

const PlayFriends = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const openedRoomRef = useRef(0);
  const roomRequestStartedRef = useRef(false);

  const flowState = useMemo(
    () =>
      buildGamificationFlowState(location.state, {
        ...getStoredGamificationFlowState(),
        entryMode: "friend",
      }),
    [location.state]
  );

  const friendFlowState = useMemo(() => ({ ...flowState, entryMode: "friend" }), [flowState]);
  const { state, createRoom, joinRoom } = useGamificationBattleSession(friendFlowState);

  const selectedBattle = state?.selectedBattle || {};
  const selectedSubject = state?.selectedSubject || {};
  const battleName =
    selectedBattle?.battles_name ||
    selectedBattle?.battle_name ||
    selectedBattle?.title ||
    "Group Battle";
  const battleNameParts = battleName.split(" ");
  const battlePrefix = battleNameParts.slice(0, -1).join(" ") || battleName;
  const battleAccent = battleNameParts.slice(-1).join(" ");
  const battleDescription =
    selectedBattle?.battles_description ||
    selectedBattle?.battle_description ||
    selectedBattle?.description ||
    "Complete, Learn & improve Daily";
  const currentCoins = Number(state?.userCoins ?? state?.user_coins ?? 0);
  const subjectName = selectedSubject?.subject_name || selectedSubject?.title || "Current Affairs";
  const subjectDescription =
    selectedSubject?.subject_description ||
    selectedSubject?.description ||
    "Current Affairs is the study of recent national and international events";
  const subjectImage =
    selectedSubject?.subject_image ||
    selectedSubject?.image ||
    selectedSubject?.image_url ||
    "";
  const entryFee = Number(
    selectedSubject?.game_entry_fee_group ??
      selectedSubject?.game_entry_fee_1vs1 ??
      selectedSubject?.game_entry_fee ??
      selectedSubject?.gameEntryFee ??
      selectedBattle?.entry_fee ??
      state?.game_entry_fee ??
      20
  );
  const nextWaitingPath = Number(state?.battles_id || 0) === 1
    ? GAMIFICATION_ROUTES.groupWaiting
    : GAMIFICATION_ROUTES.singleWaiting;

  useEffect(() => {
    if (roomRequestStartedRef.current && state?.liveStage === "private_room" && state?.battle_room_id &&
        openedRoomRef.current !== state.battle_room_id) {
      openedRoomRef.current = state.battle_room_id;
      navigate(nextWaitingPath, { state });
    }
  }, [navigate, nextWaitingPath, state]);

  const handleBack = () => {
    if (state?.gamificationBackTarget?.pathname) {
      navigate(state.gamificationBackTarget.pathname, {
        state: state.gamificationBackTarget.state || {},
      });
      return;
    }

    navigate(EXPLORE_ROUTES.subjects, {
      state: buildGamificationSubjectsState(state),
    });
  };

  const handleCreateRoom = () => {
    if (state?.room_request_pending) return;
    roomRequestStartedRef.current = createRoom();
  };

  const handleJoinRoom = (roomCode) => {
    if (state?.room_request_pending) return;
    roomRequestStartedRef.current = joinRoom(roomCode);
  };

  return (
    <>
      <style>{`
          .homeDashboard-wrapper .page-content {
            padding-right: 0;
          }
          .homeDashboard-wrapper .main-content {
            box-sizing: border-box;
            padding-bottom: 35px;
            min-height: 0;
          }
      `}</style>
      <HomeDashboardLayout showHeader={false}>
        <div className="qbl-page qbankList-page page-padding start-gamification ">
          <div className="start-quiz qbl-main instruction-main">
            <div className="hideProfile-page ">
              <div className="categories-page-header mb-0">
                <div>
                  <button type="button" className="categories-back-button" onClick={handleBack}>
                    <i className="bi bi-chevron-left"></i>
                  </button>
                </div>
                <div>
                  <h4 className="d-flex categories-page-title"> </h4>
                </div>
                <div>
                  <HeaderProfileSection />
                </div>
              </div>
            </div>

            <div className="rapid-fire-header d-flex align-items-center justify-content-between group-header">
              <div>
                <h1 className="qb-title">
                  {battlePrefix} <span>{battleAccent}</span>
                </h1>
                <p className="game-description">{battleDescription}</p>
              </div>
              <div>
                <div className="game-coin d-flex gap-2 justify-content-center align-items-center d-flex ">
                  <span>
                    <img src={CoinConverterGif} alt="" />
                  </span>
                  <span className="coin-valuee fw-bold">{currentCoins}</span>
                </div>
              </div>
            </div>

            {state?.socketError ? <div className="cs-status">{state.socketError}</div> : null}
            {!state?.socketError && state?.connectionStatus === "connecting" ? <div className="cs-status">Connecting to battle...</div> : null}

            <CreateRoom
              subjectName={subjectName}
              subjectDescription={subjectDescription}
              subjectImage={subjectImage}
              entryFee={entryFee}
              isLoading={state?.room_request_pending && state?.room_request_action === "createRoom"}
              isDisabled={state?.room_request_pending}
              onCreate={handleCreateRoom}
            />

            <JoinRoom isLoading={state?.room_request_pending && state?.room_request_action === "joinRoom"}
              isDisabled={state?.room_request_pending}
              onJoin={handleJoinRoom} resetToken={state?.liveStage === "private_room" ? state?.battle_room_id : 0} />
          </div>
        </div>
      </HomeDashboardLayout>
    </>
  );
};

export default PlayFriends;
